import { useState, useEffect } from "react";
import { db, collection, addDoc } from "../firebase";
import popupImage from "../assets/USEO.png";

export default function AuthorityBuilderFunnel() {
  const [showPopup, setShowPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const onButtonClick = () => {
    const pdfUrl = "UltimateSEOGuideWoaomWebDesign.pdf";
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "UltimateSEOGuideWoaomWebDesign.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const lastShown = localStorage.getItem("authorityFunnelPopupDate");
    const today = new Date().toDateString();

    // Only show popup on screens wider than 768px (desktop/tablet)
    if (window.innerWidth >= 768 && lastShown !== today) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem("authorityFunnelPopupDate", today);
      }, 15000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "AuthorityBuilderFunnel1"), {
        email,
        timestamp: new Date(),
      });
      setSubmitted(true);
      onButtonClick();
    } catch (err) {
      console.error("Error saving to Firebase:", err);
    }
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="relative bg-[#2E2D2B] shadow-xl w-[90%] max-w-4xl flex flex-col md:flex-row overflow-hidden">
        {/* Close Button */}
        <button
          onClick={() => setShowPopup(false)}
          className="absolute top-4 right-4 text-black text-2xl hover:text-[#C0A6F8] transition"
          aria-label="Close"
        >
          &times;
        </button>

        {/* Text + Form */}
        <div className="p-6 md:w-1/2 flex flex-col justify-center bg-[#2E2D2B]">
          <h2 className="text-3xl font-bold text-[#CFF098] italic mb-4">
            Attract High-Value Clients With The Ultimate Website & SEO Guide
          </h2>
          <p className="text-white">
            <span className="pt-2">
              Learn the exact strategies top women experts are using to build powerful online brands that convert.
            </span>
          </p>

          {!submitted && (
            <p className="text-black mt-2 bg-[#CFF098] italic">
              Enter your email below and download it right away!
            </p>
          )}

          {submitted ? (
            <p className="mt-4 text-[#C0A6F8] font-medium">
              Checklist Has Been Downloaded — Check Your Download Folder!
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F4F3E1] text-black"
              />
              <button
                type="submit"
                className="bg-[#C0A6F8] text-black px-4 py-2 rounded-lg hover:bg-[#CFF098] transition"
              >
                Get the Free Checklist
              </button>
            </form>
          )}
        </div>

        {/* Image */}
        <div className="md:w-1/2">
          <img
            src={popupImage}
            alt="Download Checklist"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
